import React from 'react';
import { Chip } from '@mui/material';

/**
 * StatusBadge — colored pill for item status.
 *
 * Props:
 *   status  : 'pending' | 'submitted' | 'overdue' | 'paid' | 'unpaid'
 *   label   : override text (optional — defaults to capitalised status)
 *   size    : 'small' (default) | 'medium'
 *   sx      : extra MUI sx overrides
 */
const STATUS_MAP = {
  pending:   { label: 'Pending',   bg: '#FFF3E0', color: '#E65100' },
  submitted: { label: 'Submitted', bg: '#E8F5E9', color: '#2E7D32' },
  overdue:   { label: 'Overdue',   bg: '#FFEBEE', color: '#C62828' },
  paid:      { label: 'Paid',      bg: '#E8F5E9', color: '#2E7D32' },
  unpaid:    { label: 'Unpaid',    bg: '#FFEBEE', color: '#C62828' },
};

const StatusBadge = ({ status = 'pending', label, size = 'small', sx = {} }) => {
  const key = status?.toLowerCase();
  const config = STATUS_MAP[key] || STATUS_MAP.pending;

  return (
    <Chip
      label={label ?? config.label}
      size={size}
      sx={{
        backgroundColor: config.bg,
        color: config.color,
        fontWeight: 700,
        fontSize: 11,
        height: 22,
        borderRadius: '6px',
        '& .MuiChip-label': { px: 1 },
        ...sx,
      }}
    />
  );
};

export default StatusBadge;
